import React from "react";
import { isThisArrayNotEmpty } from "../../../services/helpers/commonHelpers";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import classNames from "classnames";
import { SidebarMenuItemType } from "../../../services/helpers/types";
import { CurrentSidebarItemState } from "../../pages/MainPage/MainPage";

interface SidebarItemsProps {
  sidebarItems: SidebarMenuItemType[];
  currentSidebarItem: CurrentSidebarItemState;
  onPageSelect: (itemID: number) => void;
}

const SidebarItems = (props: SidebarItemsProps) => {
  const { sidebarItems, currentSidebarItem, onPageSelect } = props;
  return (
    <>
      {isThisArrayNotEmpty(sidebarItems) ? (
        sidebarItems.map((item) => (
          <ListItem
            key={item.sidebarItemID}
            disablePadding
            onClick={() => onPageSelect(item.sidebarItemID)}
            className={classNames("dui-sidebar-item", {
              "dui-sidebar-item-active":
                item.sidebarItemID === currentSidebarItem.item?.sidebarItemID,
            })}
            id={
              item.sidebarItemID === currentSidebarItem.item?.sidebarItemID
                ? "dui-sidebar-item-active"
                : ""
            }
          >
            <ListItemButton className="dui-sidebar-item-button">
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))
      ) : (
        <div>Nenájdená žiadna diagnóza</div>
      )}
    </>
  );
};

export default SidebarItems;
